module.exports = __webpack_public_path__ + "static/pin-bdd6639cdab1d9a335117329f82589ea.png";